/* global gdAlertify */
import React, { useState } from "react";
import axiosInstance from "../config/axiosConfig";
import BuscarPaciente from "./components/BuscarPaciente";
import BuscarAuxiliar from "./components/BuscarAuxiliar";
import Select from 'react-select';
import { useNavigate, useParams } from 'react-router-dom';

function SolicitudReemplazo() {
    const { id_solicitud } = useParams();
    const navigate = useNavigate();

    const [pacienteInfo, setPacienteInfo] = useState(null);
    const [auxiliarInfo, setAuxiliarInfo] = useState(null);
    const [auxiliares, setAuxiliares] = useState([]);
    const [datosCondiciones, setDatosCondiciones] = useState({
        pacienteID: 0,
        auxiliarID: 0,
        valorTurno: 0,
        valorColacion: 0,
        valorMovilizacion: 0,
        valorOtro: 0,
        fechaInicio: '',
        fechaFin: '',
        turnoID: 0
    });

    const handleSeleccionPaciente = (paciente) => {
        if (paciente.valoresTurnos && paciente.valoresTurnos.length > 0) {
            const { valorTurnoAuxiliar, valorColacionAuxiliar, valorLocomocionAuxiliar, valorOtroAuxiliar } = paciente.valoresTurnos[0];
            setDatosCondiciones({
                valorTurno: valorTurnoAuxiliar,
                valorColacion: valorColacionAuxiliar,
                valorMovilizacion: valorLocomocionAuxiliar,
                valorOtro: valorOtroAuxiliar,
                pacienteID: paciente.id,
                auxiliarID: 0,
                fechaInicio: '',
                fechaFin: '',
                turnoID: paciente.tipoTurno
            });
        }

        setPacienteInfo(paciente);
        setAuxiliares(paciente.auxiliares.map(auxiliar => ({
            value: auxiliar.id,
            label: `${auxiliar.nombre} ${auxiliar.apellidoPaterno} ${auxiliar.apellidoMaterno} (${auxiliar.rut})`
        })));
    };

    const handleSeleccionAuxiliar = (auxiliar) => {
        setDatosCondiciones(prev => ({ ...prev, auxiliarID: auxiliar.id }));
        setAuxiliarInfo(auxiliar);

        // Si viene con paciente asociado
        if (auxiliar.paciente != null) {
            const { valorTurnoAuxiliar, valorColacionAuxiliar, valorLocomocionAuxiliar, valorOtroAuxiliar } = auxiliar.paciente.valoresTurnos[0];
            setDatosCondiciones({
                valorTurno: valorTurnoAuxiliar,
                valorColacion: valorColacionAuxiliar,
                valorMovilizacion: valorLocomocionAuxiliar,
                valorOtro: valorOtroAuxiliar,
                pacienteID: auxiliar.paciente.id,
                auxiliarID: auxiliar.id,
                fechaInicio: '',
                fechaFin: '',
                turnoID: auxiliar.paciente.tipoTurno
            });
            setPacienteInfo(auxiliar.paciente);
            setAuxiliares(auxiliar.paciente.auxiliares.map(aux => ({
                value: aux.id,
                label: `${aux.nombre} ${aux.apellidoPaterno} ${aux.apellidoMaterno} (${aux.rut})`
            })));
        } else {
            // Si no viene con paciente, lo agregamos manualmente a la lista del select
            setAuxiliares(prev => {
                const existe = prev.some(a => a.value === auxiliar.id);
                if (!existe) {
                    return [...prev, {
                        value: auxiliar.id,
                        label: `${auxiliar.nombre} ${auxiliar.apellidoPaterno} ${auxiliar.apellidoMaterno} (${auxiliar.rut})`
                    }];
                }
                return prev;
            });
        }
    };

    const handleChangeCondiciones = (e) => {
        const { name, value } = e.target;
        setDatosCondiciones({ ...datosCondiciones, [name]: value });
    };

    const handleAuxiliar = (selectedOption) => {
        setDatosCondiciones({ ...datosCondiciones, auxiliarID: selectedOption ? selectedOption.value : "" });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const fechaInicio = new Date(datosCondiciones.fechaInicio);
        fechaInicio.setHours(0, 0, 0, 0);
        const fechaFin = new Date(datosCondiciones.fechaFin);
        fechaFin.setHours(0, 0, 0, 0);

        if (fechaFin < fechaInicio) {
            gdAlertify.notiError('La fecha de fin debe ser mayor a la fecha de inicio.');
            return false;
        }

        if (datosCondiciones.auxiliarID == 0 || datosCondiciones.auxiliarID == null) {
            gdAlertify.notiError('Falta seleccionar auxiliar');
            return false;
        }

        gdAlertify.confirm({
            title: 'Registrar solicitud de reemplazo',
            message: '¿Está seguro de registrar solicitud de reemplazo?',
            onConfirm: async () => {
                gdAlertify.showLoader();
                try {
                    const response = await axiosInstance.post("/reemplazos/solicitud/crear", {
                        datosCondiciones,
                    });

                    if (!response.data.error) {
                        gdAlertify.notiSuccess(response.data.message);
                        navigate('/solicitudes-reemplazos');
                    } else {
                        gdAlertify.notiError(response.data.message);
                    }
                    gdAlertify.hideLoader();
                } catch (error) {
                    gdAlertify.hideLoader();
                    console.error(error);
                    gdAlertify.notiError("Ocurrió un error al conectar con el servidor.");
                }
            },
            onCancel: () => {
                gdAlertify.notify('Envío cancelado', 'error');
            }
        });
    };

    return (
        <div className="container mt-4">
            <div className="card">
                <div className="card-body">
                    <h1 className="mb-4">Ingreso de Solicitud</h1>

                    <form onSubmit={handleSubmit}>

                        {/* Selección de Reemplazo */}
                        <div className="border p-4 mb-4">
                            <div className="row g-3 d-flex justify-content-between">
                                <div className="col-md-4">
                                    <BuscarPaciente
                                        onSelect={handleSeleccionPaciente}
                                        valoresTurnos={true}
                                        conAuxiliares={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <BuscarAuxiliar
                                        titulo="Auxiliar por reemplazar"
                                        onSelect={handleSeleccionAuxiliar}
                                        conPaciente={true}
                                    />
                                </div>
                                <div className="col-md-2 d-flex align-items-end">
                                    <button className="btn btn-primary">Seleccionar</button>
                                </div>
                            </div>
                        </div>

                        {/* Información Paciente */}
                        <div className="border p-4 mb-4">
                            <h5 className="mb-3">Información Paciente</h5>
                            <div className="row g-3">
                                <div className="col-md-4">
                                    <label className="form-label fw-bold">Nombre del Paciente</label>
                                    <p className="form-control-plaintext">{pacienteInfo ? `${pacienteInfo.nombres} ${pacienteInfo.apellidoPaterno} ${pacienteInfo.apellidoMaterno}` : ''}</p>
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label fw-bold">Dirección</label>
                                    <p className="form-control-plaintext">{pacienteInfo ? pacienteInfo.direccion : ''}</p>
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label fw-bold">Comuna</label>
                                    <p className="form-control-plaintext">{pacienteInfo ? pacienteInfo.desc_comuna : ''}</p>
                                </div>
                            </div>
                        </div>

                        {/* Seleccionar Auxiliar */}
                        <div className="border p-4 mb-4">
                            <h5 className="mb-3">Seleccione Auxiliar</h5>
                            <div className="row g-3">
                                <div className="mb-3 col-md-12">
                                    <label className="form-label">Auxiliar</label>
                                    <Select
                                        options={auxiliares}
                                        value={auxiliares.find(option => option.value === datosCondiciones.auxiliarID) || null}
                                        onChange={handleAuxiliar}
                                        placeholder="Seleccione un auxiliar"
                                        isClearable
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Fecha de Reemplazo */}
                        <div className="border p-4 mb-4">
                            <h5 className="mb-3">Fecha de Reemplazo</h5>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <label className="form-label">Inicio de Reemplazo</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        name="fechaInicio"
                                        value={datosCondiciones.fechaInicio}
                                        onChange={handleChangeCondiciones}
                                        required
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">Fin de Reemplazo</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        name="fechaFin"
                                        value={datosCondiciones.fechaFin}
                                        onChange={handleChangeCondiciones}
                                        required
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Condiciones */}
                        <div className="border p-4">
                            <h5 className="mb-3">Condiciones del Reemplazo</h5>
                            <div className="row g-3">
                                <div className="col-md-3">
                                    <label className="form-label">Valor del Turno</label>
                                    <input
                                        type="number"
                                        name="valorTurno"
                                        className="form-control"
                                        value={datosCondiciones.valorTurno}
                                        onChange={handleChangeCondiciones}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">Colación</label>
                                    <input
                                        type="number"
                                        name="valorColacion"
                                        className="form-control"
                                        value={datosCondiciones.valorColacion}
                                        onChange={handleChangeCondiciones}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">Movilización</label>
                                    <input
                                        type="number"
                                        name="valorMovilizacion"
                                        className="form-control"
                                        value={datosCondiciones.valorMovilizacion}
                                        onChange={handleChangeCondiciones}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">Otro</label>
                                    <input
                                        type="number"
                                        name="valorOtro"
                                        className="form-control"
                                        value={datosCondiciones.valorOtro}
                                        onChange={handleChangeCondiciones}
                                    />
                                </div>
                            </div>

                            <div className="text-center mt-3">
                                <button className="btn btn-primary">Ingresar Solicitud</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default SolicitudReemplazo;
